import React, { Component, PropTypes } from 'react';

import { ColumnBold, TransformText, GriddleAction } from '../../../components/utils/TableUtils';

import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';

import { NitroDataGrid, NitroIcon } from 'nitro-components';

class WorkflowSetupGrid extends Component {
  // Column definition for Driver allocation datagrid

  onDeleteClicked = (data, e) => {
    /* console.log('onDeleteClicked');
    console.log(this);
    console.log(e);
     */

    //console.log(data);
    this.props.deleteApprover(data);
    e.stopPropagation();
  };

  getColumnMetaData() {
    const columnMeta = [
      {
        columnName: 'Level',
        displayName: 'Level',
        sortable: false,
        customComponent: ColumnBold
      },
      {
        columnName: 'LevelOrder',
        displayName: 'Order',
        sortable: false,
        customComponent: TransformText
      },
      {
        columnName: 'User',
        displayName: 'Approver',
        sortable: false,
        customComponent: ({ data, rowData }) => (
          <span>
            {data.FirstName} {data.LastName}
          </span>
        )
      },
      {
        columnName: 'Docusign',
        displayName: 'Docusign',
        sortable: false,
        customComponent: ({ data, rowData }) => (
          <span>
            {data == true ? 'Yes' : 'No'}
          </span>
        )
      },
      {
        columnName: 'Delete',
        displayName: ' ',
        sortable: false,
        width: '100',
        customComponent: ({ data, rowData }) =>
          rowData.CanBeModified &&
          <span className="griddle-action">
            {' '}
            <NitroIcon
              name="delete"
              variant="secondary"
              size={16}
              alignment
              action={e => this.onDeleteClicked(rowData, e)}
            />

          </span>
      }
    ];

    return columnMeta;
  }

  render() {
    return (
      <NitroDataGrid
        results={this.props.data}
        tableClassName="table"
        totalCount={this.props.total}
        rowPerPage={this.props.rowCount}
        columnMetaData={this.getColumnMetaData()}
        onRowClick={this.props.onRowClick}
        fetchExternalData={this.props.getExternalData}
        currentPage={this.props.currentPage}
        dataFetching={this.props.dataFetching}
      />
    );
  }
}

WorkflowSetupGrid.propTypes = {
  data: PropTypes.array,
  total: PropTypes.number,
  rowCount: PropTypes.number,
  getExternalData: PropTypes.func,
  onRowClick: PropTypes.func,
  currentPage: PropTypes.number,
  dataFetching: PropTypes.bool
};

export default WorkflowSetupGrid;



// WEBPACK FOOTER //
// ./src/features/corporate-quote-workflow-setup/components/WorkflowSetupGrid.js